import React from 'react';
import PropTypes from 'prop-types';
import { SuiContainer, SuiTooltip } from '@splashthat/sui';

import './ReservedNodeIndication.styl';

const getReservedLabel = (label) => `Reserved "${label}" question.`;

const BASE_CLASS_NAME = 'ReservedNodeIndication';

// Component that has a special behavior or meaning, like first name, email, or attending yes/no.
const ReservedNodeIndication = ({ label, tooltip }) => (
    <SuiContainer variation="flex-group flex-horizontal-left" className={`${BASE_CLASS_NAME}__container`}>
        <SuiContainer className={`${BASE_CLASS_NAME}__label`}>{getReservedLabel(label)}</SuiContainer>
        <SuiTooltip>{tooltip}</SuiTooltip>
    </SuiContainer>
);

ReservedNodeIndication.propTypes = {
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
};

export default ReservedNodeIndication;
